/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { useWBL } from '../context/WBLContext';

export const ThemeManager: React.FC = () => {
  const { activeTenant } = useWBL();

  // Create customized CSS variables so Tailwind utilities can interact natively.
  // We can write a tiny style element.
  const styleContent = `
    :root {
      --primary-color: ${activeTenant.primaryColor};
      --secondary-color: ${activeTenant.secondaryColor};
      --primary-color-hover: ${activeTenant.primaryColor}dd;
      --secondary-color-hover: ${activeTenant.secondaryColor}dd;
    }
    
    /* Dynamically skin scrollbars and button accents */
    .bg-custom-primary {
      background-color: var(--primary-color) !important;
    }
    .text-custom-primary {
      color: var(--primary-color) !important;
    }
    .border-custom-primary {
      border-color: var(--primary-color) !important;
    }
    .bg-custom-secondary {
      background-color: var(--secondary-color) !important;
    }
    .text-custom-secondary {
      color: var(--secondary-color) !important;
    }
    .border-custom-secondary {
      border-color: var(--secondary-color) !important;
    }
    
    /* Custom buttons with hover feedback */
    .btn-custom-primary {
      background-color: var(--primary-color) !important;
      color: #ffffff !important;
      transition: all 150ms ease;
    }
    .btn-custom-primary:hover {
      background-color: var(--primary-color-hover) !important;
      transform: translateY(-1px);
    }
    .btn-custom-secondary {
      background-color: var(--secondary-color) !important;
      color: #ffffff !important;
      transition: all 150ms ease;
    }
    .btn-custom-secondary:hover {
      background-color: var(--secondary-color-hover) !important;
      transform: translateY(-1px);
    }
    
    /* Soft colored badges */
    .badge-custom-light {
      background-color: ${activeTenant.primaryColor}15 !important;
      color: var(--primary-color) !important;
    }
  `;

  return <style dangerouslySetInnerHTML={{ __html: styleContent }} />;
};
